"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.filterChildren = filterChildren;
var _react = require("react");
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
function filterChildren(predicate) {
  return (0, _compose["default"])((0, _filter["default"])(predicate), _react.Children.toArray);
}
var _default = exports["default"] = filterChildren;